import type { IAppRegion } from '~/lib/appSettings';

export const getPathFromRegion = (region: IAppRegion): string =>
  region.slice('crowdaa-'.length);
